export default __webpack_public_path__ + "static/media/loading.9895ec4e.svg";